import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function ProductDetail() {
  const { pid } = useParams();
  const [p, setP] = useState(null);
  const { addToCart } = useApp();
  const [qty, setQty] = useState(1);

  useEffect(() => {
    api.get(`/products/${pid}`).then(({ data }) => setP(data));
  }, [pid]);

  if (!p) return <div className="max-w-7xl mx-auto px-6 py-16">Loading...</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 py-10" data-testid="product-detail-page">
      <Link to="/shop" className="text-sm text-pink-600 font-semibold">← Back to shop</Link>
      <div className="grid md:grid-cols-2 gap-10 mt-4">
        <div className="card-soft overflow-hidden">
          <img src={p.image_url} alt={p.name} className="w-full aspect-square object-cover" />
        </div>
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">{p.name}</h1>
          <div className="text-pink-600 font-bold text-3xl mt-3">${p.price.toFixed(2)}</div>
          <p className="text-slate-600 mt-5">{p.blurb}</p>
          <div className="mt-7 flex items-center gap-3">
            <div className="flex items-center bg-white rounded-full ring-1 ring-pink-100 px-3 py-1">
              <button data-testid="qty-decrement" className="px-2 text-pink-600 font-bold" onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
              <span data-testid="qty-value" className="px-3 font-bold">{qty}</span>
              <button data-testid="qty-increment" className="px-2 text-pink-600 font-bold" onClick={() => setQty((q) => q + 1)}>+</button>
            </div>
            <button data-testid="add-to-cart-btn" className="btn-pink" onClick={() => { addToCart(p, qty); toast.success(`${p.name} added to cart`); }}>
              Add to Cart
            </button>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-3 text-sm">
            <div className="card-soft p-3">Sensory-safe</div>
            <div className="card-soft p-3">Dropship-ready</div>
            <div className="card-soft p-3">Family-tested</div>
            <div className="card-soft p-3">In stock</div>
          </div>
        </div>
      </div>
    </div>
  );
}
